module.exports = __webpack_public_path__ + "media/images/guyane-e193fe879433392b65b787d2f39c4fa6.svg";